import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './counterSlice'
import { loadStateFromLocalStorage, saveStateToLocalStorage } from '../utils/constants';

const persistedState = loadStateFromLocalStorage();

const store = configureStore({
    reducer: {
        Head: counterReducer
    },
    preloadedState: persistedState, 
})

store.subscribe(() => {
    const stateToPersist = store.getState()
    saveStateToLocalStorage(stateToPersist);
  });
  
export default store;



